/**
 * LCC 补涨列表：与补涨分析单龙头计分同构（名称共字 + 概念；主属性高亮 +5，其余龙头概念 +1）
 */
import { CONCEPT_SOURCE_MERGE } from '@/utils/conceptSource'
import { resolveAnalysisConcepts } from '@/utils/conceptFilter'

const SCORE_THRESHOLD = 6

export function normCode6(code) {
  const s = String(code || '').replace(/\D/g, '')
  return s.length >= 6 ? s.slice(-6) : s
}

function nameCharScore(leaderName, stockName) {
  const a = String(leaderName || '').replace(/\s+/g, '')
  const b = String(stockName || '').replace(/\s+/g, '')
  if (!a || !b) return 0
  let score = 0
  for (let i = 0; i < b.length; i += 1) {
    if (a.includes(b[i])) score += 1
  }
  return score
}

/**
 * @param {object} opts
 * @param {string} opts.leaderName
 * @param {string} opts.leaderCode
 * @param {string[]} opts.leaderConcepts
 * @param {string} opts.selectedConcept 点选主属性（概念名）
 * @param {Array} opts.limitUpRows getLimitUpStocks.data
 * @param {number} [opts.threshold=8]
 * @param {number} [opts.conceptSource]
 */
export function matchCatchupAgainstLimitUp({
  leaderName,
  leaderCode,
  leaderConcepts,
  selectedConcept,
  limitUpRows,
  threshold = SCORE_THRESHOLD,
  conceptSource = CONCEPT_SOURCE_MERGE
}) {
  const selected = String(selectedConcept || '').trim()
  if (!selected) return []

  const leaderConceptList = (leaderConcepts || [])
    .map((c) => String(c || '').trim())
    .filter(Boolean)
  const leaderSet = new Set(leaderConceptList)
  // 保证点选主属性也在计分概念池中
  if (!leaderSet.has(selected)) {
    leaderConceptList.push(selected)
    leaderSet.add(selected)
  }

  const selfCode = normCode6(leaderCode)
  const rows = []

  for (const stock of limitUpRows || []) {
    const code = normCode6(stock.code || stock.ts_code)
    if (!code || (selfCode && code === selfCode)) continue

    const concepts = resolveAnalysisConcepts(stock.concepts, stock.kplConcepts, conceptSource, stock.localConcepts)
    let nameScore = nameCharScore(leaderName, stock.name)
    let generalScore = 0
    let highlightedScore = 0
    let hitSelected = false

    for (const concept of concepts) {
      if (!leaderSet.has(concept)) continue
      if (concept === selected) {
        highlightedScore += 5
        hitSelected = true
      } else {
        generalScore += 1
      }
    }

    const totalScore = nameScore + generalScore + highlightedScore
    if (totalScore < threshold) continue

    const consecutiveBoards = Number(stock.consecutiveBoards)
    const midChip = Number(stock.midChip)
    const freeFloatMarketCap = Number(stock.freeFloatMarketCap)
    const firstBoardPrice = Number(stock.firstBoardPrice)
    rows.push({
      code,
      name: stock.name || code,
      totalScore,
      matchScore: { value: totalScore, quality: 'VALID' },
      matchedAttrLabel: hitSelected ? selected : '',
      conceptDetail: hitSelected ? selected : '',
      watchStage: null,
      boardStageLabel: null,
      changePct: null,
      consecutiveBoards: Number.isFinite(consecutiveBoards) ? consecutiveBoards : null,
      consecutiveBoardsLabel: stock.consecutiveBoardsLabel || null,
      midChip: Number.isFinite(midChip) ? midChip : null,
      freeFloatMarketCap: Number.isFinite(freeFloatMarketCap) ? freeFloatMarketCap : null,
      firstBoardDate: stock.firstBoardDate || null,
      firstBoardPrice: Number.isFinite(firstBoardPrice) ? firstBoardPrice : null,
      /** 首板日市场节点分，由 LCC 侧按 firstBoardDate 补齐 */
      nodeScore: null,
      nodeHit: false
    })
  }

  rows.sort((a, b) => {
    if (b.totalScore !== a.totalScore) return b.totalScore - a.totalScore
    return String(a.code).localeCompare(String(b.code))
  })
  return rows
}

export { SCORE_THRESHOLD }
